import { ComponentType } from '@angular/cdk/overlay';
import { InjectionToken } from '@angular/core';

export const CMS_COMPONENT_TYPE: InjectionToken<ComponentType<unknown>> =
  new InjectionToken<ComponentType<unknown>>('CMS component constructor');
